import { groupBy, sortBy } from "lodash";
import { useMemo } from "react";
import { useDictionary } from "../../.."
import { dictionaryService } from "../../../dataFlow"
import { SLIDE_NUMBER } from "../constants";

export function useTableFootnote() {
  const [calendarDictItems] = useDictionary(dictionaryService, 'slides-calendar-slide12');
  const [commoditiesDictItems] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    'slide': SLIDE_NUMBER,
    'business_unit': 1,
  });
  const footnote = useMemo(() => {
    const items = calendarDictItems?.map(calendarItem => {
      const commodityId = calendarItem.getValue<number>('commodity_id');
      const commodityItem = commoditiesDictItems?.find(commodityItem =>
        commodityItem.getValue<number>('olap_commodity') === commodityId
      );
      const commodityName = commodityItem?.getValue<any>('name')[9];
      const calendarName = calendarItem.getValue<any>('name')[9];
      const [day, month, year] = calendarName.split('/');
      const date = (`${month}/${day}/${year}`);
      return ({
        commodityName: commodityName?.split(',')[0] || '',
        calendar: date,
      });
    });
    const groups = groupBy(items, item => item.calendar);
    const groupDates = sortBy(Object.keys(groups), groupDate => groups[groupDate].length).reverse();
    const result = groupDates.reduce((output, groupDate) => {
      const groupCommodities = groups[groupDate].map(item => item.commodityName);
      const [_day, month, _date, year] = new Date(groupDate).toDateString().split(' ');
      const groupName = `${month} ${year}`;
      const groupOutput = [groupCommodities.join(', '), groupName].join(' - ');
      return [output, groupOutput].filter(Boolean).join('; ');
    }, "");
    return result;
  }, [calendarDictItems, commoditiesDictItems]);
  return footnote;
}